import { StorageBucketConfig } from './storage-bucket-config'

export class StorageBucket implements StorageBucketConfig {

  region: string
  bucket: string
  folder: string
  domain: string

  constructor(data: StorageBucketConfig) {
    this.region = data.region
    this.bucket = data.bucket
    this.folder = data.folder
    this.domain = data.domain
  }

  public getUrl(key: string): string {
    return key ? (
      this.folder ? `https://${this.domain}/${this.folder}/${key}` : `https://${this.domain}/${key}`
    ) : null
  }

  public get_url(key: string): string {
    return key ? (
      this.folder ? `https://${this.domain}/${this.folder}/${key}` : `https://${this.domain}/${key}`
    ) : null
  }

  public get_oss_url(key: string): string {
    return key ? (
      this.folder ?
      `https://${this.bucket}.${this.region}.aliyuncs.com/${this.folder}/${key}`
      : `https://${this.bucket}.${this.region}.aliyuncs.com/${key}`
    ) : null
  }

  public get_full_key(key: string): string {
    return this.folder ? `${this.folder}/${key}` : key
  }

}



// WEBPACK FOOTER //
// ./src/app/models/media/storage-bucket.ts